import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * GpProductFilterSearch Atom Module
 */
export class GpProductFilterSearch extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Product Filter Search';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'product-filter-search';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
